import { useOktaAuth, LoginCallback } from '@okta/okta-react';
import { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

// Helpers
import { setStorageItem } from 'commons/helpers/storage-helper';
import { customDelay } from 'commons/helpers/utils';

function LoginStaffCallbackView({ userActions }) {
  const { setUserInfo, getUserByEmail } = userActions;
  const { authState } = useOktaAuth();
  const history = useHistory();

  const isAuthenticated = useMemo(() => {
    return authState?.isAuthenticated;
  }, [authState]);

  const onNavigation = async () => {
    await customDelay(800);

    history.push(`/main/dashboard`);
  };

  const onGetUserData = async (_, response) => {
    if (response?.data) {
      await setStorageItem('user', response.data);
      await setUserInfo(response.data, onNavigation);
    }
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const setTokenAndFetchUser = async () => {
      const { email } = authState.idToken.claims;
      await setStorageItem('oktaEmailAuthenticated', email);
      await setStorageItem('okta-token-storage', authState);
      await getUserByEmail({ email }, onGetUserData);
    };

    if (authState && isAuthenticated) {
      setTokenAndFetchUser();
    } else {
      setStorageItem('oktaEmailAuthenticated', null);
    }
  }, [authState?.isAuthenticated]);

  return <LoginCallback loadingElement={<p>Cargando...</p>} />;
}

LoginStaffCallbackView.propTypes = {
  userActions: PropTypes.shape({
    setUserInfo: PropTypes.func.isRequired,
    getUserByEmail: PropTypes.func.isRequired
  }).isRequired,
  clinicId: PropTypes.any
};

LoginStaffCallbackView.defaultProps = {};

export default LoginStaffCallbackView;
